import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const GET_ALL_ROUTE_TRACKING_LOADING = 'GET_ALL_ROUTE_TRACKING_LOADING';
export const GET_ALL_ROUTE_TRACKING_SUCCESS = 'GET_ALL_ROUTE_TRACKING_SUCCESS';
export const GET_ALL_ROUTE_TRACKING_REJECT = 'GET_ALL_ROUTE_TRACKING_REJECT';

//* ACTIONS ------------------------------------------------
export const getAllTrackingRouteLoading = () => ({ type: GET_ALL_ROUTE_TRACKING_LOADING });
export const getAllTrackingRouteSuccess = (payload) => ({ type: GET_ALL_ROUTE_TRACKING_SUCCESS, payload });
export const getAllTrackingRouteReject = (payload) => ({ type: GET_ALL_ROUTE_TRACKING_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const getAllTrackingRouteRequest = async (params = {}, getState) => {
    const options = await withToken({
        method: Methods.GET,
        params,
    }, getState);
    return request(`/Route/web/GetAllOnRoutes`, options);
};